import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../CancelButton';
import CreateButton from '../CreateButton';
import Errored from '../Errored';
import Help from '../Help';
import IRIgeneration from '../IRIgeneration';
import LabelledSwitch from '../LabelledSwitch';
import OrderedUnordered from '../OrderedUnordered';
import PrimaryButton from '../PrimaryButton';
import SlashHash from '../SlashHash';
import { globalStyles as styles } from '../style/gstheme';
import TitledTextField from '../TitledTextField';
import { MAX_DESCRIPTION_LENGTH, MAX_TITLE_LENGTH } from '../utils/constants';
import BaseIRI from './BaseIRI';
import TitledPanel from '../TitledPanel';

class ComponentDialog extends React.Component {

    state = {
        open: false,
        title: "",
        description: "",
        iriType: "Slash",
        orderType: "Ordered",
        defaultToXL: false,
        iriFormat: "UUID",
        primaryCounter: 1,
        secondaryCounter: 10000000,
        isValidIRI: false,
        componentIRI: ""
    };

    handleClickOpen = () => { this.setState({ open: true }); };

    addComponent = () => {
        this.setState({ open: false });
        const isSlashIRI = this.props.slashHash ? this.state.iriType === 'Slash' : null;
        const isUuidIRI = this.props.slashHash ? this.state.iriFormat === 'UUID' : null;
        const counterIRIs = this.props.slashHash && this.state.iriFormat === 'Counter' ?
            {
                primaryCounter: this.state.primaryCounter - 1,
                secondaryCounter: this.state.secondaryCounter - 1
            }
            :
            null;
        const isOrdered = this.props.order ? this.state.orderType === 'Ordered' : false;
        this.props.onAddComponent(this.state.title.trim(), this.state.componentIRI, isSlashIRI,
            this.state.description.trim(), this.props.lang, isOrdered, isUuidIRI, this.state.defaultToXL, counterIRIs);
        this.setState({
            title: "",
            description: "",
            componentIRI: "",
            primaryCounter: 1,
            secondaryCounter: 10000000,
            isValidIRI: false,
            defaultToXL: false,
            orderType: "Ordered",
            iriFormat: "UUID",
            iriType: "Slash"
        });
    };

    exitAddComponent = () => {
        this.setState({
            title: "",
            description: "",
            componentIRI: "",
            primaryCounter: 1,
            secondaryCounter: 10000000,
            open: false,
            isValidIRI: false,
            defaultToXL: false,
            orderType: "Ordered",
            iriFormat: "UUID",
            iriType: "Slash"
        });
    };

    handleChange = event => {
        const t = event.target;
        this.setState({ [t.name]: t.value.trimLeft() });
    };

    handleXLChange = (defaultToXL) => this.setState({ defaultToXL });

    handleIRIChange = (componentIRI, isValidIRI) => this.setState({ componentIRI, isValidIRI, checking: false });

    handlePrimaryChange = (event) => this.setState({ primaryCounter: Number(event.target.value) });

    handleSecondaryChange = (event) => this.setState({ secondaryCounter: Number(event.target.value) });

    onUpdateIRI = () => this.setState({ isValidIRI: false, checking: true });

    render() {

        const { classes, lang, label, slashHash, order, dataTest, useXL, project, existingComponents, allowCounter, showSecondaryCounter } = this.props;
        const { title, description, iriType, iriFormat, orderType, defaultToXL, isErrored, checking, isValidIRI, primaryCounter, secondaryCounter } = this.state;

        if (isErrored) return <Errored data={isErrored} />;

        const countersInvalid = iriFormat === "Counter" ?
            (showSecondaryCounter && secondaryCounter <= primaryCounter) || primaryCounter <= 0 || secondaryCounter <= 0
            :
            false;

        return (
            <React.Fragment>
                <CreateButton dataTest={"create-" + dataTest} onClick={this.handleClickOpen} label={label} />
                <Dialog
                    data-test="create-component"
                    maxWidth="lg"
                    classes={{
                        paper: classes.paper,
                        paperWidthLg: classes.largeDialog
                    }}
                    open={this.state.open} onClose={this.exitAddComponent} aria-labelledby="component-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="component-dialog-title">{label}</DialogTitle>
                    <DialogContent>
                        <Help textRef="IRI" />
                        <form aria-label="Component detail" autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="title"
                                name="title"
                                title="Title"
                                ariaLabel="Title"
                                autoFocus={true}
                                required={true}
                                text={title}
                                placeholder="Enter title"
                                maxLength={MAX_TITLE_LENGTH}
                                lang={lang}
                                onChange={this.handleChange} />
                            <BaseIRI
                                existingComponents={existingComponents}
                                project={project}
                                ariaLabel="Component IRI"
                                onUpdateIRI={this.onUpdateIRI}
                                onValidatedIRI={this.handleIRIChange} />
                            <TitledTextField
                                dataTest="description"
                                name="description"
                                title="Description"
                                ariaLabel="Description"
                                text={description}
                                placeholder="Enter description"
                                margin={true}
                                maxLength={MAX_DESCRIPTION_LENGTH}
                                lang={lang}
                                onChange={this.handleChange} />
                            {slashHash &&
                                <div style={{ width: '100%', display: 'flex' }}>
                                    <div style={{ flex: 1, marginRight: '8px' }}>
                                        <SlashHash onChange={this.handleChange} iriType={iriType} />
                                    </div>
                                    <div style={{ flex: 1, marginLeft: '8px', minWidth: 360 }}>
                                        <IRIgeneration
                                            allowCounter={allowCounter}
                                            onChange={this.handleChange}
                                            primaryCounter={primaryCounter}
                                            handlePrimaryChange={this.handlePrimaryChange}
                                            handleSecondaryChange={this.handleSecondaryChange}
                                            secondaryCounter={secondaryCounter}
                                            showSecondaryCounter={showSecondaryCounter}
                                            showCounters={iriFormat === "Counter"}
                                            iriFormat={iriFormat} />
                                    </div>
                                </div>
                            }
                            {useXL &&
                                <LabelledSwitch
                                    dataTest="defaultToXL"
                                    disabled={false}
                                    checked={defaultToXL}
                                    handleChange={this.handleXLChange}
                                    label="Use XL for Labels" />
                            }
                            {order &&
                                <TitledPanel margin={true} title="Type of Collection">
                                    <OrderedUnordered onChange={this.handleChange} orderType={orderType} />
                                </TitledPanel>
                            }
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddComponent} />
                        <PrimaryButton
                            disabled={title.length === 0 || !isValidIRI || checking || countersInvalid}
                            onClick={this.addComponent}>Create</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

ComponentDialog.defaultProps = {
    order: false,
    useXL: false,
    allowCounter: false,
    showSecondaryCounter: false,
    existingComponents: []
};

ComponentDialog.propTypes = {
    classes: PropTypes.object,
    dataTest: PropTypes.string,
    existingComponents: PropTypes.array,
    label: PropTypes.string.isRequired,
    lang: PropTypes.string,
    project: PropTypes.string.isRequired,
    slashHash: PropTypes.bool.isRequired,
    allowCounter: PropTypes.bool,
    showSecondaryCounter: PropTypes.bool,
    useXL: PropTypes.bool,
    order: PropTypes.bool,
    onAddComponent: PropTypes.func.isRequired
};

export default withStyles(styles)(ComponentDialog);